import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/index.css';

import GA4React from 'ga-4-react'; // Google Analytics
import TagManager from 'react-gtm-module'; // Google Tag Manager

// Navigation (used React-Router V6)
import {
  BrowserRouter,
  Routes,
  Route,
} from 'react-router-dom';

// Juntos+ client-side pages (login not needed)
import Login from './pages/Login/Login';
import Signin from './pages/Signin/Signin';
import ResultsPublic from './pages/Results/ResultsPublic';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import ForgotEmail from './pages/ForgotEmail/ForgotEmail';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import NewEmail from './pages/NewEmail/NewEmail';
import PhoneNumberConfirmation from './pages/ForgotEmail/PhoneNumberConfirmation';

/* 
Maybe, in the future there will be a landing page to this hub. Now,
it only redirects the user to login
*/
// Juntos+ client-side pages (login needed)
import Home from './pages/Home/Home';
import MyNumbers from './pages/MyNumbers/MyNumbers';
import MyPrizes from './pages/MyPrizes/MyPrizes';
import Promos from './pages/Promos/Promos';
import Results from './pages/Results/Results';
import Profile from './pages/Profile/Profile';

// Admin pages
import HomeAdmin from './admin/pages/Home';
import LoginAdmin from './admin/pages/Login/Login';
import RegisteredAdmin from './admin/pages/Registered';
import ElegiblesAdmin from './admin/pages/Elegibles';
import VouchersAdmin from './admin/pages/Vouchers';
import ResultsAdmin from './admin/pages/Results';
import DrawsAdmin from './admin/pages/Draws';
import ActivityAdmin from './admin/pages/Activity';
import RegisterAdmin from './admin/pages/Register';
import AcompanharAdmin from './admin/pages/Acompanhar';
import EmailChangeRequests from './admin/pages/EmailChangeRequests';
import AdminLayout from './admin/components/Layout/AdminLayout';
import UserLayout from './components/UserLayout/UserLayout';
import Fallback from 'pages/Fallback/Fallback';

// Initialize GA4
const ga4react = new GA4React(process.env.REACT_APP_GA_TRACKING_ID);
ga4react.initialize().then().catch();

// Initialize GTM
const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_TRACKING_ID,
};
TagManager.initialize(tagManagerArgs);

// All routes and pages loaded
function App() {

  const clientRoutes = [
    {path: "", element: <Login />},
    {path: "login", element: <Login />},
    {path: "signin", element: <Signin />},
    {path: "esqueci-minha-senha", element: <ForgotPassword />},
    {path: "esqueci-meu-email", element: <ForgotEmail />},
    {path: "resultados-publico", element: <ResultsPublic />},
    {path: "confirmar-telefone", element: <PhoneNumberConfirmation />},
    {path: "novo-email", element: <NewEmail />},
    {path: "redefinir-senha", element: <ResetPassword />},
    {path: "home", element: <Home />},
    {path: "resultados", element: <Results />},
    {path: "numeros", element: <MyNumbers />},
    {path: "premios", element: <MyPrizes />},
    {path: "promos", element: <Promos />},
    {path: "perfil", element: <Profile />},
  ];

  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<UserLayout />}>
          {clientRoutes.map(({path}) =>
            <Route key={`${path}-fallback`} path={`/${path}`} element={<Fallback />} />
          )}
          <Route path="/:promo">
            {clientRoutes.map(({ path, element }) =>
              <Route key={path} path={path} element={element} />
            )}
          </Route>
        </Route>
        <Route path="/admin" element={<LoginAdmin />} />
        <Route path="/admin" element={<AdminLayout />}>
            <Route path="home" element={<HomeAdmin />} />
            <Route path="cadastrados" element={<RegisteredAdmin />} />
            <Route path="elegiveis" element={<ElegiblesAdmin />} />
            <Route path="numeros" element={<VouchersAdmin />} />
            <Route path="resultados" element={<ResultsAdmin />} />
            <Route path="sorteios" element={<DrawsAdmin />} />
            <Route path="atividade" element={<ActivityAdmin />} />
            <Route path="adicionar" element={<RegisterAdmin />} />
            <Route path="acompanhar" element={<AcompanharAdmin />} />
            <Route path="mudanca-email" element={<EmailChangeRequests />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
